<template>
    <v-container fluid fill-height>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                    <v-toolbar color="primary" flat>
                        <v-toolbar-title class="white--text">FORM COMPLETION PIN</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <div class="subtitle-2">
                            We have sent your form completion PIN to your
                            <span class="contactMethodText">{{ contactMethodText }}</span>. Please enter the PIN if you have received it and click LOGIN.
                            If the PIN is not received after two minutes, please click Resend
                            PIN.
                        </div>
                        <v-form ref="entryForm" v-model="formValid" @submit.prevent>
                            <v-container>
                                <v-row>
                                    <v-col class="pa-0" cols="12" md="6">
                                        <v-text-field label="Enter PIN"
                                                      v-model="dataEntryPIN"
                                                      prepend-icon="mdi-cellphone-key"
                                                      maxlength="6"
                                                      inputmode="numeric"
                                                      clearable
                                                      :rules="[rules.required]"
                                                      :error="pinError"
                                                      :error-messages="pinErrorMessage"
                                                      @click:clear="clearCustomError"
                                                      @change="clearCustomError"></v-text-field>
                                    </v-col>
                                    <v-col class="pa-0 text-center text-md-start"
                                           cols="12"
                                           md="6">
                                        <v-btn @click="resendFormSubmissionPIN"
                                               :disabled="btnResendPINDisabled"
                                               class="ml-2 mt-3 indigo lighten-5"
                                               tile
                                               outlined
                                               :loading="pinGenerationBusy">
                                            <v-icon left>mdi-reload</v-icon>Resend PIN
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-3"
                               @click="dataEntryLogin"
                               :loading="progressStatus"
                               color="primary"
                               width="100"
                               large>LOGIN</v-btn>
                        <v-spacer></v-spacer>
                        <v-progress-linear :active="progressStatus"
                                           absolute
                                           bottom
                                           :indeterminate="progressStatus"
                                           color="deep-purple accent-4"></v-progress-linear>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dlgInfo" persistent max-width="600px">
            <v-card>
                <v-card-title class="justify-center primary">
                    <span class="headline text-center white--text">INFORMATION</span>
                </v-card-title>
                <v-card-text class="text-center pt-2">
                    <span class="subtitle-1 form-completion-info-dialog-text">
                        {{ dlgMessage }}
                    </span>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn @click="closeInfoDialog" class="primary mb-2" width="100" large>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="formSubmitBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ formSubmitBusyText }}
                    <v-progress-linear indeterminate
                                       color="white"
                                       class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    /* eslint-disable */
    import axios from "axios";
    import { mapMutations, mapGetters, mapActions } from "vuex";
    import { eventCallbacks } from "../handcrafted/CrfCallbacks.js";

    export default {
        data() {
            return {
                dataEntryPIN: null,
                pinGenerationBusy: false,
                btnResendPINDisabled: false,
                formValid: true,
                progressStatus: false,
                pinError: false,
                pinErrorMessage: "",
                dlgInfo: false,
                dlgMessage: "",
                formSubmitBusy: false,
                formSubmitBusyText: "",
                contactMethodText: "",
                baseUrl: "api/DataEntry/",
                rules: {
                    required: (value) => !!value || "Required.",
                },
            };
        },
        methods: {
            ...mapMutations([
                "setFormAuthenticated",
                "setDataEntryPin",
                "setFormGuid",

                //TODO
                "resetDataEntry",
                "setAppBusyAnimation",
                "setMainMenuDrawer",
            ]),
            dataEntryLogin: async function () {
                if (!this.formValid || !this.$route.query.formGroupId) {
                    return;
                }
                this.progressStatus = true;

                const pinStatus = await this.$store.dispatch(
                    "getPinStatus", { pin: this.dataEntryPIN, guid: this.$route.query.id }
                );
                //debugger;
                if (pinStatus != 0) {
                    //invalid PIN
                    this.pinErrorMessage =
                        "Failed to login, please make sure the information you are entering is correct.";
                    this.pinError = true;
                    this.progressStatus = false;
                    return;
                }
                this.setDataEntryPin(this.dataEntryPIN);

                let eventID = this.$route.query.formGroupId;
                if (!eventID) {
                    this.$router.push("/");
                } else {
                    eventCallbacks[eventID].onLoad.call(this.$router, this.$route);
                }
            },
            closeInfoDialog: function () {
                this.dlgInfo = false;
            },
            clearCustomError: function () {
                this.pinErrorMessage = "";
                this.pinError = false;
            },
            sendFormSubmissionPinGuid: async function () {
                this.btnResendPINDisabled = true;
                setTimeout(() => {
                    this.btnResendPINDisabled = false;
                }, 120000);

                let id = this.$route.query.id;
                if (!id) {
                    return;
                }
                try {
                    const actionUrl = "api/Notification/SendFormSubmissionPinGuid";
                    const {
                        data: { statusCode, message },
                    } = await axios.get(actionUrl, {
                        params: { guid: id },
                    });
                    this.contactMethodText =
                        statusCode === 0 ? message : "mobile-phone/email-address";
                    return 0;
                } catch (error) {
                    return -1;
                }
            },
            resendFormSubmissionPIN: async function () {
                this.pinGenerationBusy = true;
                this.dataEntryPIN = null;
                await this.sendFormSubmissionPinGuid();
                this.pinGenerationBusy = false;
            },
        },
        computed: {
            ...mapGetters(["getFormGuid", "getMenuItems", "getDataEntryPin"]),
        },
        async mounted() {
            this.setAppBusyAnimation(true);

            this.resetDataEntry();
            await this.sendFormSubmissionPinGuid();

            this.setAppBusyAnimation(false);
        },
    };
</script>
<style>
    .form-completion-info-dialog-text {
        padding-top: 10px;
        color: #212121;
    }

    .contactMethodText {
        font-weight: bold;
        text-transform: uppercase;
    }
</style>
